import React from 'react';
import FormikSearchDropdown from 'src/components/formik/FormikSearchDropdown/FormikSearchDropdown';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import PropTypes from 'prop-types';
import { commissionSearchAPI } from 'src/api/CommissionApi';
import { targetSearchAPI } from 'src/api/TargetApi';

const TargetDropDown = ({ value, name, ...rest }) => (
    <FormikSearchDropdown
        name={name}
        placeholder="Select Target Slab"
        displayKeyPath={[
            'targetName',
        ]}
        valueKeyPath="_id"
        defaultValueFetchByKeyPath="_id"
        whereClauseKeysPaths={[
            'targetName',
        ]}
        api={targetSearchAPI}
        apiCallAddonData={{
            pageLength: '',
        }}
        value={value}
        {...rest}
    />
);

TargetDropDown.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
};

TargetDropDown.defaultProps = { value: '' };

export default TargetDropDown;
